import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Benvenuti su BluCall",
    title: "Connessioni Wireless {ad Alte Prestazioni}",
    price: "A partire da €13,90",
    priceUnit: "per mese",
    buttonText: "Per saperne di più",
    buttonLink: "Pricing",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Benvenuti su BluCall",
    title: "Fibbra {FTTC / FTTH}",
    price: "€ 29,90",
    priceUnit: "per mese",
    buttonText: "Per saperne di più",
    buttonLink: "Pricing",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Benvenuti su BluCall",
    title: "Telefonia Mobile con {Number Portability}",
    price: "Canone Voce € 4,00",
    priceUnit: "per mese",
    buttonText: "Per saperne di più",
    buttonLink: "Pricing",
  },
];

export default home;